import { Card, Col, Result, Row, Spin } from 'antd';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { AotvLogo } from '../components/AotvLogo';
import { PageHead } from '../components/PageHead';
import { api } from '../lib/api';
import { useAuth, type Session } from '../lib/auth';

type AcceptResponse = { token: string; email: string; eventId: string };

export function AcceptInviteScene() {
  const { token } = useParams<{ token: string }>();
  const navigate = useNavigate();
  const { setSession } = useAuth();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!token) return;
    void (async () => {
      try {
        const res = await api<AcceptResponse>('/api/invite/accept', {
          method: 'POST',
          body: JSON.stringify({ token }),
        });
        const session: Session = {
          token: res.token,
          email: res.email,
          role: 'speaker',
        };
        setSession(session);
        navigate(`/waiting/${res.eventId}`, { replace: true });
      } catch (err) {
        setError((err as { error?: string }).error ?? 'Invalid or expired invite');
      }
    })();
  }, [token, setSession, navigate]);

  return (
    <div className="auth-container">
      <PageHead title="Joining event" />
      <Row justify="center">
        <Col xs={22} sm={20} md={14} lg={10} xl={8}>
          <div className="auth-logo">
            <AotvLogo />
          </div>
          <Card>
            {error ? (
              <Result status="error" title="Invite invalid" subTitle={error} />
            ) : (
              <div style={{ textAlign: 'center', padding: 24 }}>
                <Spin /> <span style={{ marginLeft: 12 }}>Accepting invite…</span>
              </div>
            )}
          </Card>
        </Col>
      </Row>
    </div>
  );
}
